const types = {
  SET_JOB_STATUS_DATA: 'SET_JOB_STATUS_DATA',
  SET_JOB_STATUS_DETAIL:"SET_JOB_STATUS_DETAIL"
}
export default types;
